import { atom } from 'jotai'
import { makeData } from 'utils/makeData'

export const roomTitleAtom = atom('Room')
export const mobilePageTitleAtom = atom('')
export const roomImageAtom = atom(null)
export const roomListFilteredAtom = atom([])
export const roomSearchAtom = atom('')
export const profileActiveTabAtom = atom('My account')

export const localeAtom = atom('en')

const gameList = makeData('game', 5)
export const gameListAtom = atom(gameList)

const roomList = makeData('room', 117)
export const roomListAtom = atom(roomList)

const userData = makeData('user', 1)
export const userDataAtom = atom(userData)

const defaultAvaData = makeData('image', 12)
export const defaultAvaAtom = atom(defaultAvaData)
